import { Component, Input, OnInit } from '@angular/core';

import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-image-carousel',
    templateUrl: './image-carousel.component.html',
    styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit {

    @Input() items: WebItem[];

    constructor() { }

    ngOnInit() { }

}
